import React, { Component } from 'react';
import { CardProps } from '../../shared/Types';

export default class Card extends Component<CardProps> {
  constructor(props: CardProps) {
    super(props);
  }

  render() {
    return (
      <div className="card" data-testid="card">
        <img src={this.props.image} className="card__img" alt="card image" />
        <div className="card__content">
          <h3 className="card__title">{this.props.title}</h3>
          <div className="card__description">{this.props.description}</div>
          <div className="card__info">
            <span className="card__bookmark">{this.props.bookmarks}</span>
            <span className="card__likes">{this.props.likes}</span>
          </div>
        </div>
      </div>
    );
  }
}
